import { MonitorUp, MonitorX } from "lucide-react";
import { Button } from "@shared/ui/Button";
import { VideoUIContainerBreakpoints } from "../../videoUI.types";
import { videoEventBus } from "../../../video/videoEventBus";
import { useBrowserCompatibilityFeatures } from "../../../video/hooks/useBrowserCompatibilityFeatures";

export type Props = {
  label?: string;
  isLocalUserSharing: boolean;
  onToggleContentShare: () => void;
  onTogglePauseContentShare: () => void;
  containerBreakpoints: VideoUIContainerBreakpoints;
};

export function VideoUIControlsContentShare({
  label = "Share Screen",
  isLocalUserSharing,
  onToggleContentShare,
  onTogglePauseContentShare,
  containerBreakpoints,
  ...rest
}: Props) {
  // Get browser compatibility features
  const { supportsScreenShare } = useBrowserCompatibilityFeatures();

  const handleToggleContentShare = () => {
    // Track the event BEFORE toggling (based on current state)
    if (isLocalUserSharing) {
      videoEventBus.emitEvent("videochat:screen:unshared", {});
    } else {
      videoEventBus.emitEvent("videochat:screen:shared", {});
    }

    onToggleContentShare();
  };

  return (
    <>
      <Button
        iconComponent={isLocalUserSharing ? MonitorX : MonitorUp}
        onClick={supportsScreenShare ? handleToggleContentShare : () => {}}
        destructive={isLocalUserSharing}
        disabled={!supportsScreenShare}
        variant="ghost"
        theme="dark"
        {...rest}
      >
        {containerBreakpoints && containerBreakpoints.isMd
          ? isLocalUserSharing
            ? "Stop Sharing"
            : label
          : ""}
      </Button>
    </>
  );
}

export default VideoUIControlsContentShare;
